import React, { useState } from 'react';

const states = {
  open: ['Open', 'Ready to open.'],
  not_assigned: ['Not assigned', 'Your organization includes this application, but you are not assigned to it.'],
  not_included: ['Not included', 'This application is not included for your organization.'],
  unavailable: ['Unavailable', 'This application or its configuration is currently unavailable.'],
  coming_soon: ['Coming soon', 'This application is coming soon.'],
};

export default function AppCard({ app, onLaunch, busy }) {
  const [selected, setSelected] = useState('');
  const state = Object.prototype.hasOwnProperty.call(states, app.state) ? app.state : 'unavailable';
  const [label, message] = states[state];
  const instances = state === 'open' && Array.isArray(app.instances) ? app.instances : [];
  const applicationId = instances.length === 1 ? instances[0].applicationId : selected;
  const canLaunch = state === 'open' && instances.some(instance => instance.applicationId === applicationId);
  return (
    <article className="app-card" aria-label={app.displayName}>
      <h2>{app.displayName}</h2>
      <p>{app.description}</p>
      {instances.length > 1 && <label className="managed-app-selector">
        Application instance
        <select aria-label={`${app.displayName} application instance`} value={selected} disabled={busy}
          onChange={event => setSelected(event.target.value)}>
          <option value="">Select an instance</option>
          {instances.map(instance => <option key={instance.applicationId} value={instance.applicationId}>
            {instance.displayName || instance.applicationId}
          </option>)}
        </select>
      </label>}
      <div className="app-card-footer">
      <span title={message} className={`app-card-status ${state === 'open' ? '' : 'app-card-status-muted'}`}>{label}</span>
      {state === 'open' && <button className="app-primary-button" type="button"
        disabled={busy || !canLaunch} aria-label={`Open ${app.displayName}`}
        onClick={() => { if (canLaunch && !busy) onLaunch(applicationId); }}>Open</button>}
      </div>
    </article>
  );
}
